import { useQuery } from "@tanstack/react-query";
import { School, SchoolModel } from "model";

import { api } from "~utils";

/**
 * Returns `schools` if there is cached data or data, otherwise, return `undefined`
 */
export const useSchools = () => {
  return useQuery({
    queryKey: ["schools"],
    queryFn: async () => (await api({ url: "/api/admin/schools" })).data.data,
    select: (schools: School[]) => schools.map((school: School) => new SchoolModel(school)),
  }).data;
};

/**
 * Returns `school` if there is cached data or data, otherwise, return `undefined`
 */
export const useSchool = (schoolId: string) => {
  return useQuery({
    enabled: !!schoolId,
    queryKey: ["schools", schoolId],
    queryFn: async () => (await api({ url: `/api/admin/school/${schoolId}` })).data.data,
    select: (school: School) => new SchoolModel(school),
  }).data;
};
